import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'glo-toggle',
  imports: [],
  templateUrl: './glo-toggle.component.html',
  styleUrl: './glo-toggle.component.scss'
})
export class GloToggleComponent {
  @Input() value: boolean = false;
  @Output() valueChange = new EventEmitter<boolean>();

  toggle(): void {
    this.value = !this.value;
    this.valueChange.emit(this.value);
  }
}
